import { Button, Result, Row, Select, Spin, Typography, UploadProps } from "antd";
import { InboxOutlined } from '@ant-design/icons';
import Dragger from "antd/lib/upload/Dragger";
import Axios from "axios";
import React, { useEffect, useState } from "react";

function getName(value: string) {
    switch (value) {
        case "selected":
            return "Affectation"
        case "statut":
            return "Statut"
        case "ca_objectif":
            return "Objectif de facturation"
    }
}

const props: UploadProps = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    onDrop(e) {
        console.log('Dropped files', e.dataTransfer.files);
    },
};

export function MassImport() {

    const [selectOptions, setSelectOptions] = useState<any[]>([])
    const [selectValue, setSelectValue] = useState<any>(null)

    const [selectColOptions, setSelectColOptions] = useState<any[]>([])
    const [selectColValue, setSelectColValue] = useState<any>(null)

    const [uploading, setUploading] = useState<boolean>(false)
    const [result, setResult] = useState<boolean | null>(null)
    const [errorMessage, setErrorMessage] = useState<string>("")

    useEffect(() => {
        Axios.get('/cnegoces/getAllCnAccesses').then(res => {
            setSelectOptions(res.data)
        })
    }, [])

    useEffect(() => {
        if (selectValue) {
            setSelectColOptions(JSON.parse(selectValue.cols).filter((e: any) => (e.coltype == 'custom' && e.custom.inputtype != "multiple-labels") || (
                e.name == "selected" ||
                e.name == "statut" ||
                e.name == "ca_objectif"
            )).map((e: any) => {
                if (e.coltype == "custom") {
                    if (e.name && e.name != "") {
                        e.name = e.name
                    }
                    else {
                        e.name = e.custom.name
                    }
                }
                else {
                    e.name = getName(e.name)
                }
                return e
            }))
        }
    }, [selectValue])

    return (
        <>
            {result == null && (
                <>
                    <Typography.Title style={{ marginTop: '20px' }} level={5}>Choix de l'outil</Typography.Title>
                    <Select disabled={uploading} style={{ width: 500 }} showSearch
                        filterOption={(input, option) => (option?.label?.toString().toLowerCase() || '').includes(input.toLowerCase())}
                        options={selectOptions.map(e => {
                            return { label: e.orga, value: e.soft_access_id }
                        })}
                        onChange={(value) => { setSelectValue(selectOptions.find(e => e.soft_access_id === value)) }}
                        value={selectValue?.soft_access_id}
                    />
                    {selectValue && (
                        <>
                            <br />
                            <Typography.Title style={{ marginTop: '20px' }} level={5}>Choix de la colonne</Typography.Title>
                            <Select disabled={uploading} style={{ width: 500 }} showSearch
                                filterOption={(input, option) => (option?.label?.toString().toLowerCase() || '').includes(input.toLowerCase())}
                                options={selectColOptions.map((e: any) => { return { label: e.name, value: e.id } })}
                                onChange={(value: any) => { setSelectColValue(selectColOptions.find(e => e.id == value)) }} />
                        </>
                    )}
                    {selectColValue && (
                        <Dragger
                            disabled={uploading}
                            {...props}
                            onChange={(info) => {
                                const { status } = info.file;
                                if (status == 'uploading') {
                                    setUploading(true)
                                }
                                if (status === 'done') {
                                    setUploading(false)
                                    setResult(true)
                                    console.log(`${info.file.name} file uploaded successfully.`);
                                } else if (status === 'error') {
                                    setUploading(false)
                                    setResult(false)
                                    setErrorMessage(info.file.response)
                                    console.error(`${info.file.name} file upload failed.`);
                                }
                            }}
                            style={{ cursor: 'pointer', marginTop: '20px', padding: '20px', border: 'solid 1px #1890ff', borderRadius: '20px', width: '250px' }}
                            action={document.location.origin + '/cnegoces/uploadMassModificationFile/' + selectValue?.soft_access_id + '/' + selectColValue?.id}
                        >
                            <InboxOutlined style={{ fontSize: 50, width: '100%', color: "#1890ff" }} />
                            <br />
                            <br />
                            <Typography.Text style={{ textAlign: 'center' }}>Cliquez ou déposez votre fichier</Typography.Text>
                        </Dragger >
                    )
                    }
                </>
            )}
            {uploading && (
                <Row style={{ marginTop: '50px' }}><Spin /><Typography.Title level={2}>Enregistrement en cours ...</Typography.Title></Row>
            )}
            {result != null && (
                <Result
                    status={result ? "success" : "error"}
                    title={result ? "L'enregistrement est réussi !" : "Une Erreur est survenue..."}
                    subTitle={result ? "" : errorMessage}
                    extra={[
                        <Button type="primary" onClick={() => setResult(null)}>
                            J'ai compris
                        </Button>,
                    ]}
                />
            )}

        </>
    )
}